import {
  FilterTypeEqual,
  RenderTableFilterOptionProps,
} from '@monetize/types/common';
import { MainSearchInput } from '../../MCustomSelect/components/MainSearchInput';
import { MCustomSelect } from '../../MCustomSelect/MCustomSelect';

export const TeamTableFilterOptionContent = ({
  filter,
  filterOption,
  handleFilterChange,
}: RenderTableFilterOptionProps) => {
  const internalFilter = filter as FilterTypeEqual;

  return (
    <MCustomSelect
      clearable
      useMainInputAsSearchInput
      itemTitle="name"
      itemValue="id"
      displayAvatar
      endpoint={`/api/teams`}
      loadAll
      MainInputComponent={MainSearchInput}
      value={internalFilter?.value}
      onChange={(val) => {
        handleFilterChange(val, filterOption);
      }}
    />
  );
};
